var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { V as VisibleConditionalSchema } from "../../VisibleConditional-7a953c26.js";
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { f as VisibleConditionTypeEnum } from "../../enums-86f58524.js";
import { S as SpriteSchema } from "../../Sprite-7d2a5fa7.js";
import { M as MapSpriteSchema } from "../../MapSprite-b447e6f3.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../types.js";
import "../../utils/byteArray.js";
class VisibleConditionalSystem {
  constructor() {
    __publicField(this, "type", "VisibleConditional");
    __publicField(this, "schema", VisibleConditionalSchema);
    __publicField(this, "depth", DEPTHS.PREDRAW);
    __publicField(this, "dependencies", ["Sprite"]);
  }
  run(entity, gameModel) {
    const player = gameModel.players[0];
    if (player == void 0) {
      return;
    }
    const visibleConditional = gameModel.getComponent(entity, this.type);
    let sprite;
    if (gameModel.hasComponent(entity, "Sprite")) {
      sprite = gameModel.getTypedUnsafe(entity, SpriteSchema);
    } else if (gameModel.hasComponent(entity, "MapSprite")) {
      sprite = gameModel.getTypedUnsafe(entity, MapSpriteSchema);
    } else {
      return;
    }
    const conditions = visibleConditional.conditions;
    for (let i = 0; i < conditions.length; i++) {
      const condition = conditions[i];
      if (condition.key === "hasComponent") {
        if (gameModel.hasComponent(player, condition.component)) {
          sprite.opacity = 1;
          return;
        }
      } else {
        const component = gameModel.getComponent(player, condition.component);
        if (component) {
          const value = component[condition.key];
          if (value) {
            switch (condition.valueType) {
              case VisibleConditionTypeEnum.STRING:
                if (condition.stringValue === value) {
                  sprite.opacity = 1;
                  return;
                }
                break;
              case VisibleConditionTypeEnum.BOOLEAN:
                if (condition.booleanValue === value) {
                  sprite.opacity = 1;
                  return;
                }
                break;
              case VisibleConditionTypeEnum.NUMBER:
                if (condition.numberValue === value) {
                  sprite.opacity = 1;
                  return;
                }
                break;
            }
          }
        }
      }
    }
    sprite.opacity = 0;
  }
  cleanup(entity, gameModel, ejecting) {
    if (ejecting)
      return;
    const sprite = gameModel.getTypedUnsafe(entity, SpriteSchema);
    sprite.opacity = 1;
  }
}
registerSystem(VisibleConditionalSystem);
//# sourceMappingURL=VisibleConditional.js.map
